import { useEffect, useCallback } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { setUrlParam } from 'helpers/http';
import {
    customerIsLoggedInSelector,
    customerLoadingStateSelector
  } from 'store/customer/selectors';
import { isServerSideRendering } from 'helpers/env';
import { isFetching, isInitialized } from 'store/constants';
import { openCustomerLoginModal } from 'store/modal/actions';

export const useAuthentication = (): void => {
  const dispatch = useDispatch();
  const redirectUrl = isServerSideRendering() ? '/' : window.location.pathname;
  const getAuthUrl = useCallback(
      (url: string) => {
      const nextUrl = setUrlParam(url, 'redirectTo', redirectUrl);
      return nextUrl;
      },
      [redirectUrl]
  );
  
  const isLoggedIn = useSelector(customerIsLoggedInSelector, shallowEqual);
  const customerLoadingState = useSelector(customerLoadingStateSelector, shallowEqual);
  useEffect(() => {
      if (!isInitialized(customerLoadingState) && !isFetching(customerLoadingState) && !isLoggedIn) {
        dispatch(openCustomerLoginModal());
      }
  // TODO: Refactor this dependency
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, getAuthUrl, customerLoadingState]);
};